// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../node_modules/css-loader/dist/cjs.js!./reset.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Diphylleia&family=Nunito:wght@300;400;500;600&family=Open+Sans:wght@300;400;500;600;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: 'LPMQ';
  src: url('https://uminabdillah.github.io/fonts/lpmq.eot');
  src: url('https://uminabdillah.github.io/fonts/lpmq.eot?#iefix') format('embedded-opentype'),
    url('https://uminabdillah.github.io/fonts/lpmq.ttf') format('truetype');
  font-weight: 400;
  font-weight: normal;
  font-display: swap;
}
:root {
  --maincolor: rgb(147, 196, 169);
}
button:focus,
input:focus,
select:focus {
  outline: none;
}
#main {
  min-height: 60vh;
}
select {
  background-color: #fff;
  color: #555;
  font-size: 0.78rem;
  border: 0;
  padding: 0.4rem 0.9rem;
  border-radius: 0.1rem;
  -webkit-border-radius: 0.1rem;
  -moz-border-radius: 0.1rem;
  -ms-border-radius: 0.1rem;
  -o-border-radius: 0.1rem;
  margin-left: 0.6rem;
  max-width: 150px;
}
a {
  text-decoration: none;
  color: inherit;
}
body {
  font-family: 'Nunito', sans-serif;
  line-height: 1.5rem;
}
.notFoundPage {
  background-color: #fafafa;
  border: 1px solid #333;
  margin: 2rem;
  padding: 1rem 2rem;
  overflow: hidden;
  text-align: center;
  box-shadow: 7px 7px 0px rgba(0, 0, 0, 0.5);
  transition: all 0.3s ease-in-out;
  -webkit-transition: all 0.3s ease-in-out;
  -moz-transition: all 0.3s ease-in-out;
  -ms-transition: all 0.3s ease-in-out;
  -o-transition: all 0.3s ease-in-out;
  border-radius: 0.5rem;
  -webkit-border-radius: 0.5rem;
  -moz-border-radius: 0.5rem;
  -ms-border-radius: 0.5rem;
  -o-border-radius: 0.5rem;
}
.notFoundPage h1 {
  font-size: 1.5rem;
  font-weight: bolder;
  margin: 1rem 0;
}
.notFoundPage a {
  text-decoration: underline;
}
.container {
  width: 100%;
  max-width: 1015px;
  margin: auto;
  background-color: white;
}
header {
  color: #eee;
  text-align: center;
  padding: 0.5rem 0;
}
header h1 {
  font-family: 'Diphylleia', sans-serif;
  color: #333;
  font-size: 2.4rem;
  padding: 1.4rem 0;
  font-weight: bolder;
  margin-bottom: 1rem;
}
header img {
  transition: all 0.3s ease-in-out;
  -webkit-transition: all 0.3s ease-in-out;
  -moz-transition: all 0.3s ease-in-out;
  -ms-transition: all 0.3s ease-in-out;
  -o-transition: all 0.3s ease-in-out;
}
header img:hover {
  opacity: 0.8;
}
.shalatScheduleContainer {
  background-color: #9db6a7;
  display: flex;
  gap: 1rem;
  align-items: center;
  justify-content: space-between;
  padding: 1rem 2rem;
  overflow-x: auto;
  font-size: 0.9rem;
}
.shalatSchedContent .left {
  text-align: center;
}
.shalatScheduleContainer .left a {
  font-family: 'Diphylleia', sans-serif;
  font-size: 1.3rem;
}
.shalatSchedContent {
  display: flex;
}
.shalatSchedContent .schedItem {
  text-align: center;
  border-left: 1px solid #306c4925;
  padding: 0 1rem;
}
.schedItem:last-child {
  border-right: 1px solid #306c4925;
}
.schedTime {
  text-transform: capitalize;
}
.topNav {
  padding: 0.5rem 2.5rem;
  background: #87ad96;
  margin-bottom: 1rem;
}
.topNav .topNavContainer {
  width: 100%;
  max-width: 1015px;
  margin: auto;
}
.topNav .left {
  display: flex;
  position: absolute;
  left: 0;
  top: 16rem;
  flex-direction: column;
  text-align: left;
  width: 100%;
  background-color: #ddd;
  z-index: 10;
  max-height: 0;
  overflow: hidden;
  transition: all 0.2s ease-in-out;
  -webkit-transition: all 0.2s ease-in-out;
  -moz-transition: all 0.2s ease-in-out;
  -ms-transition: all 0.2s ease-in-out;
  -o-transition: all 0.2s ease-in-out;
}
.topNav .right {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  list-style: none;
  padding: 0;
  margin: 0;
  gap: 1.5rem;
}
.topNav .right li {
  width: 10px;
}
.topNav .left li {
  border-bottom: 1px solid #dadada;
}
.topNav .left a,
.topNav .right a {
  color: #333;
  font-size: 0.88rem;
  font-weight: bolder;
  padding: 0.3rem;
}
.topNav .left a {
  display: block;
  padding: 0.8rem;
}
button.hamburger {
  width: 100%;
  padding: 0.6rem 0;
  border: none;
  font-size: 1.2rem;
  cursor: pointer;
}
.surahSearch {
  height: auto;
  margin: 2rem 0;
  display: flex;
  justify-content: center;
}
.surahSearch input {
  padding: 0.5rem 6rem 0.5rem 0.4rem;
  border: transparent;
  background-color: transparent;
}
.surahSearch .searchBoxContainer {
  background-color: #eee;
  width: auto;
  padding-right: 0.4rem;
  border: 1px solid #333;
  overflow: hidden;
  border-radius: 0.5rem;
  -webkit-border-radius: 0.5rem;
  -moz-border-radius: 0.5rem;
  -ms-border-radius: 0.5rem;
  -o-border-radius: 0.5rem;
}
.surahContainer {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 1.2rem;
  padding: 1rem;
  margin-bottom: 2rem;
}
.surah {
  background-color: #eee;
  padding: 1rem;
  border: 1px solid #333;
  box-shadow: 7px 7px 0px rgba(0, 0, 0, 0.5);
  border-radius: 0.4rem;
  -webkit-border-radius: 0.4rem;
  -moz-border-radius: 0.4rem;
  -ms-border-radius: 0.4rem;
  -o-border-radius: 0.4rem;
  transition: all 0.3s ease-in-out;
  -webkit-transition: all 0.3s ease-in-out;
  -moz-transition: all 0.3s ease-in-out;
  -ms-transition: all 0.3s ease-in-out;
  -o-transition: all 0.3s ease-in-out;
}
.surah:hover {
  background-color: #aec4b7;
}
.surah h2 {
  font-size: 1.2rem;
  margin-bottom: 0.5rem;
}
.arabic {
  font-family: LPMQ, 'Traditional Arabic', Tahoma, sans-serif;
  color: goldenrod;
  line-height: 5rem;
  font-weight: normal;
  text-align: right;
  direction: rtl;
}
.surahDetailContainer {
  line-height: 1.5rem;
}
.surahDetailContainer .menu {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  gap: 1rem;
}
.surahDetailMain {
  padding: 3rem 1rem;
}
.surahDetailContainer .titleContainer {
  text-align: center;
  font-size: 2rem;
}
.surahDetailContainer .titleContainer p {
  font-size: 1.1rem;
}
.menu {
  padding: 1rem;
  font-size: 0.89rem;
  color: #333;
}
.menu select {
  border: 1px solid #555;
  border-radius: 0.5rem;
  -webkit-border-radius: 0.5rem;
  -moz-border-radius: 0.5rem;
  -ms-border-radius: 0.5rem;
  -o-border-radius: 0.5rem;
}
.menu a {
  font-size: 0.89rem;
  color: #333;
}
.ayat,
.tafsirBody {
  background-color: #fafafa;
  border: 1px solid #333;
  margin-bottom: 2rem;
  padding: 1rem 2rem;
  overflow: hidden;
  box-shadow: 7px 7px 0px rgba(0, 0, 0, 0.5);
  transition: all 0.3s ease-in-out;
  -webkit-transition: all 0.3s ease-in-out;
  -moz-transition: all 0.3s ease-in-out;
  -ms-transition: all 0.3s ease-in-out;
  -o-transition: all 0.3s ease-in-out;
  border-radius: 0.5rem;
  -webkit-border-radius: 0.5rem;
  -moz-border-radius: 0.5rem;
  -ms-border-radius: 0.5rem;
  -o-border-radius: 0.5rem;
}
.ayat:hover {
  background-color: #efefef;
  border-radius: 0.5rem;
  -webkit-border-radius: 0.5rem;
  -moz-border-radius: 0.5rem;
  -ms-border-radius: 0.5rem;
  -o-border-radius: 0.5rem;
}
.ayatsTitle {
  font-size: 1.5rem;
  margin: 2rem 0;
  text-align: center;
}
.ayatHead {
  text-align: right;
}
.ayatHead h3 {
  font-size: 1rem;
  line-height: 2.3rem;
}
.ayatHead h3.arabic {
  margin-bottom: 0.5rem;
}
.ayatHead p {
  color: #555;
  font-size: 0.9rem;
}
.ayatBody p {
  margin: 2rem 0;
}
.audioContainer {
  display: flex;
  align-items: center;
}
audio {
  width: 170px;
  transform: scale(0.8);
  -webkit-transform: scale(0.8);
  -moz-transform: scale(0.8);
  -ms-transform: scale(0.8);
  -o-transform: scale(0.8);
}
audio::-webkit-media-controls-panel {
  background-color: #ddd;
}
a.ayatTafsir {
  font-size: 0.8rem;
  background-color: #ddd;
  color: #333;
  padding: 0.5rem 0.7rem;
  transition: all 0.3s ease-in-out;
  -webkit-transition: all 0.3s ease-in-out;
  -moz-transition: all 0.3s ease-in-out;
  -ms-transition: all 0.3s ease-in-out;
  -o-transition: all 0.3s ease-in-out;
  border-radius: 0.5rem;
  -webkit-border-radius: 0.5rem;
  -moz-border-radius: 0.5rem;
  -ms-border-radius: 0.5rem;
  -o-border-radius: 0.5rem;
}
a.ayatTafsir:hover {
  background-color: #bbb;
}
.nomorAyat {
  font-weight: bolder;
  padding: 0.2rem 0.7rem;
  background-color: #555;
  color: white;
  font-size: 0.9rem;
  border-radius: 0.5rem;
  -webkit-border-radius: 0.5rem;
  -moz-border-radius: 0.5rem;
  -ms-border-radius: 0.5rem;
  -o-border-radius: 0.5rem;
}
.tafsirBody {
  margin-top: 3rem;
}
.ayatFooter {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.6rem;
}
footer {
  background-color: #2c3e50;
  text-align: center;
  padding: 2rem 0;
  color: var(--maincolor);
  font-size: 0.9rem;
}
.loading {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 2rem 0;
  position: fixed;
  height: 100vh;
  top: 0;
  left: 0;
  background-color: rgba(255, 255, 255, 0.8);
  z-index: 100;
}
.hide {
  display: none;
}
.lds-ripple {
  display: inline-block;
  position: relative;
  width: 80px;
  height: 80px;
}
.lds-ripple div {
  position: absolute;
  border: 4px solid #333;
  opacity: 1;
  border-radius: 50%;
  animation: lds-ripple 1s cubic-bezier(0, 0.2, 0.8, 1) infinite;
}
.lds-ripple div:nth-child(2) {
  animation-delay: -0.5s;
}
@keyframes lds-ripple {
  0% {
    top: 36px;
    left: 36px;
    width: 0;
    height: 0;
    opacity: 0;
  }
  4.9% {
    top: 36px;
    left: 36px;
    width: 0;
    height: 0;
    opacity: 0;
  }
  5% {
    top: 36px;
    left: 36px;
    width: 0;
    height: 0;
    opacity: 1;
  }
  100% {
    top: 0px;
    left: 0px;
    width: 72px;
    height: 72px;
    opacity: 0;
  }
}
@media screen and (min-width: 835px) {
  header h1 {
    font-size: 2.6rem;
  }
  .topNav .topNavContainer {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .topNav .left {
    display: flex;
    gap: 1.6rem;
    flex-direction: row;
    position: static;
    background-color: transparent;
    max-height: 100px;
    width: auto;
  }
  .topNav .left li {
    border-bottom: none;
  }
  .topNav .left a {
    display: block;
    padding: 0;
  }
  .surahDetailContainer .menu {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .surahDetailMain {
    padding: 3rem;
  }
  .ayat {
    padding: 2rem;
  }
  .menuAndNavDraw button {
    display: none;
  }
  button.hamburger {
    display: none;
  }
  .ayatHead h3 {
    font-size: 1.3rem;
  }
  .ayatFooter {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
  }
  audio {
    width: 300px;
    transform: scale(0.9);
    -webkit-transform: scale(0.9);
    -moz-transform: scale(0.9);
    -ms-transform: scale(0.9);
    -o-transform: scale(0.9);
  }
}
.show {
  max-height: 1000px !important;
}
/* Colors */
.audioPlaying {
  background-color: rgba(218, 165, 32, 0.2);
}
.audioPlaying:hover {
  background-color: rgba(218, 165, 32, 0.3);
}
.yellow {
  color: rgb(191, 131, 20);
}
.gold {
  color: goldenrod;
}
.logo {
  color: goldenrod;
  width: 3 rem;
  height: 3 rem;
}
`, "",{"version":3,"sources":["webpack://./src/styles/main.css"],"names":[],"mappings":"AAEA;EACE,mBAAmB;EACnB,yDAAyD;EACzD;2EACyE;EACzE,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,+BAA+B;AACjC;AACA;;;EAGE,aAAa;AACf;AACA;EACE,gBAAgB;AAClB;AACA;EACE,sBAAsB;EACtB,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,sBAAsB;EACtB,qBAAqB;EACrB,6BAA6B;EAC7B,0BAA0B;EAC1B,yBAAyB;EACzB,wBAAwB;EACxB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE,iCAAiC;EACjC,mBAAmB;AACrB;AACA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,0CAA0C;EAC1C,gCAAgC;EAChC,wCAAwC;EACxC,qCAAqC;EACrC,oCAAoC;EACpC,mCAAmC;EACnC,qBAAqB;EACrB,6BAA6B;EAC7B,0BAA0B;EAC1B,yBAAyB;EACzB,wBAAwB;AAC1B;AACA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,WAAW;EACX,iBAAiB;EACjB,YAAY;EACZ,uBAAuB;AACzB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,qCAAqC;EACrC,WAAW;EACX,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,gCAAgC;EAChC,wCAAwC;EACxC,qCAAqC;EACrC,oCAAoC;EACpC,mCAAmC;AACrC;AACA;EACE,YAAY;AACd;AACA;EACE,yBAAyB;EACzB,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,qCAAqC;EACrC,iBAAiB;AACnB;AACA;EACE,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,eAAe;AACjB;AACA;EACE,iCAAiC;AACnC;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,iBAAiB;EACjB,YAAY;AACd;AACA;EACE,aAAa;EACb,kBAAkB;EAClB,OAAO;EACP,UAAU;EACV,sBAAsB;EACtB,gBAAgB;EAChB,WAAW;EACX,sBAAsB;EACtB,WAAW;EACX,aAAa;EACb,gBAAgB;EAChB,gCAAgC;EAChC,wCAAwC;EACxC,qCAAqC;EACrC,oCAAoC;EACpC,mCAAmC;AACrC;AACA;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;EACE,gCAAgC;AAClC;AACA;;EAEE,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,cAAc;EACd,eAAe;AACjB;AACA;EACE,WAAW;EACX,iBAAiB;EACjB,YAAY;EACZ,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,YAAY;EACZ,cAAc;EACd,aAAa;EACb,uBAAuB;AACzB;AACA;EACE,kCAAkC;EAClC,mBAAmB;EACnB,6BAA6B;AAC/B;AACA;EACE,sBAAsB;EACtB,WAAW;EACX,qBAAqB;EACrB,sBAAsB;EACtB,gBAAgB;EAChB,qBAAqB;EACrB,6BAA6B;EAC7B,0BAA0B;EAC1B,yBAAyB;EACzB,wBAAwB;AAC1B;AACA;EACE,aAAa;EACb,4DAA4D;EAC5D,WAAW;EACX,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,0CAA0C;EAC1C,qBAAqB;EACrB,6BAA6B;EAC7B,0BAA0B;EAC1B,yBAAyB;EACzB,wBAAwB;EACxB,gCAAgC;EAChC,wCAAwC;EACxC,qCAAqC;EACrC,oCAAoC;EACpC,mCAAmC;AACrC;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,iBAAiB;EACjB,qBAAqB;AACvB;AACA;EACE,2DAA2D;EAC3D,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,SAAS;AACX;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,sBAAsB;EACtB,qBAAqB;EACrB,6BAA6B;EAC7B,0BAA0B;EAC1B,yBAAyB;EACzB,wBAAwB;AAC1B;AACA;EACE,kBAAkB;EAClB,WAAW;AACb;AACA;;EAEE,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,0CAA0C;EAC1C,gCAAgC;EAChC,wCAAwC;EACxC,qCAAqC;EACrC,oCAAoC;EACpC,mCAAmC;EACnC,qBAAqB;EACrB,6BAA6B;EAC7B,0BAA0B;EAC1B,yBAAyB;EACzB,wBAAwB;AAC1B;AACA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,6BAA6B;EAC7B,0BAA0B;EAC1B,yBAAyB;EACzB,wBAAwB;AAC1B;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,iBAAiB;AACnB;AACA;EACE,cAAc;AAChB;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,qBAAqB;EACrB,6BAA6B;EAC7B,0BAA0B;EAC1B,yBAAyB;EACzB,wBAAwB;AAC1B;AACA;EACE,sBAAsB;AACxB;AACA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,WAAW;EACX,sBAAsB;EACtB,gCAAgC;EAChC,wCAAwC;EACxC,qCAAqC;EACrC,oCAAoC;EACpC,mCAAmC;EACnC,qBAAqB;EACrB,6BAA6B;EAC7B,0BAA0B;EAC1B,yBAAyB;EACzB,wBAAwB;AAC1B;AACA;EACE,sBAAsB;AACxB;AACA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,sBAAsB;EACtB,YAAY;EACZ,iBAAiB;EACjB,qBAAqB;EACrB,6BAA6B;EAC7B,0BAA0B;EAC1B,yBAAyB;EACzB,wBAAwB;AAC1B;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,WAAW;AACb;AACA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,uBAAuB;EACvB,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,aAAa;EACb,MAAM;EACN,OAAO;EACP,0CAA0C;EAC1C,YAAY;AACd;AACA;EACE,aAAa;AACf;AACA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,UAAU;EACV,kBAAkB;EAClB,8DAA8D;AAChE;AACA;EACE,sBAAsB;AACxB;AACA;EACE;IACE,SAAS;IACT,UAAU;IACV,QAAQ;IACR,SAAS;IACT,UAAU;EACZ;EACA;IACE,SAAS;IACT,UAAU;IACV,QAAQ;IACR,SAAS;IACT,UAAU;EACZ;EACA;IACE,SAAS;IACT,UAAU;IACV,QAAQ;IACR,SAAS;IACT,UAAU;EACZ;EACA;IACE,QAAQ;IACR,SAAS;IACT,WAAW;IACX,YAAY;IACZ,UAAU;EACZ;AACF;AACA;EACE;IACE,iBAAiB;EACnB;EACA;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;EACrB;EACA;IACE,aAAa;IACb,WAAW;IACX,mBAAmB;IACnB,gBAAgB;IAChB,6BAA6B;IAC7B,iBAAiB;IACjB,WAAW;EACb;EACA;IACE,mBAAmB;EACrB;EACA;IACE,cAAc;IACd,UAAU;EACZ;EACA;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;EACrB;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,iBAAiB;EACnB;EACA;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,eAAe;EACjB;EACA;IACE,YAAY;IACZ,qBAAqB;IACrB,6BAA6B;IAC7B,0BAA0B;IAC1B,yBAAyB;IACzB,wBAAwB;EAC1B;AACF;AACA;EACE,6BAA6B;AAC/B;AACA,WAAW;AACX;EACE,yCAAyC;AAC3C;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,aAAa;AACf","sourcesContent":["@import url('./reset.css');\n@import url('https://fonts.googleapis.com/css2?family=Diphylleia&family=Nunito:wght@300;400;500;600&family=Open+Sans:wght@300;400;500;600;700&display=swap');\n@font-face {\n  font-family: 'LPMQ';\n  src: url('https://uminabdillah.github.io/fonts/lpmq.eot');\n  src: url('https://uminabdillah.github.io/fonts/lpmq.eot?#iefix') format('embedded-opentype'),\n    url('https://uminabdillah.github.io/fonts/lpmq.ttf') format('truetype');\n  font-weight: 400;\n  font-weight: normal;\n  font-display: swap;\n}\n:root {\n  --maincolor: rgb(147, 196, 169);\n}\nbutton:focus,\ninput:focus,\nselect:focus {\n  outline: none;\n}\n#main {\n  min-height: 60vh;\n}\nselect {\n  background-color: #fff;\n  color: #555;\n  font-size: 0.78rem;\n  border: 0;\n  padding: 0.4rem 0.9rem;\n  border-radius: 0.1rem;\n  -webkit-border-radius: 0.1rem;\n  -moz-border-radius: 0.1rem;\n  -ms-border-radius: 0.1rem;\n  -o-border-radius: 0.1rem;\n  margin-left: 0.6rem;\n  max-width: 150px;\n}\na {\n  text-decoration: none;\n  color: inherit;\n}\nbody {\n  font-family: 'Nunito', sans-serif;\n  line-height: 1.5rem;\n}\n.notFoundPage {\n  background-color: #fafafa;\n  border: 1px solid #333;\n  margin: 2rem;\n  padding: 1rem 2rem;\n  overflow: hidden;\n  text-align: center;\n  box-shadow: 7px 7px 0px rgba(0, 0, 0, 0.5);\n  transition: all 0.3s ease-in-out;\n  -webkit-transition: all 0.3s ease-in-out;\n  -moz-transition: all 0.3s ease-in-out;\n  -ms-transition: all 0.3s ease-in-out;\n  -o-transition: all 0.3s ease-in-out;\n  border-radius: 0.5rem;\n  -webkit-border-radius: 0.5rem;\n  -moz-border-radius: 0.5rem;\n  -ms-border-radius: 0.5rem;\n  -o-border-radius: 0.5rem;\n}\n.notFoundPage h1 {\n  font-size: 1.5rem;\n  font-weight: bolder;\n  margin: 1rem 0;\n}\n.notFoundPage a {\n  text-decoration: underline;\n}\n.container {\n  width: 100%;\n  max-width: 1015px;\n  margin: auto;\n  background-color: white;\n}\nheader {\n  color: #eee;\n  text-align: center;\n  padding: 0.5rem 0;\n}\nheader h1 {\n  font-family: 'Diphylleia', sans-serif;\n  color: #333;\n  font-size: 2.4rem;\n  padding: 1.4rem 0;\n  font-weight: bolder;\n  margin-bottom: 1rem;\n}\nheader img {\n  transition: all 0.3s ease-in-out;\n  -webkit-transition: all 0.3s ease-in-out;\n  -moz-transition: all 0.3s ease-in-out;\n  -ms-transition: all 0.3s ease-in-out;\n  -o-transition: all 0.3s ease-in-out;\n}\nheader img:hover {\n  opacity: 0.8;\n}\n.shalatScheduleContainer {\n  background-color: #9db6a7;\n  display: flex;\n  gap: 1rem;\n  align-items: center;\n  justify-content: space-between;\n  padding: 1rem 2rem;\n  overflow-x: auto;\n  font-size: 0.9rem;\n}\n.shalatSchedContent .left {\n  text-align: center;\n}\n.shalatScheduleContainer .left a {\n  font-family: 'Diphylleia', sans-serif;\n  font-size: 1.3rem;\n}\n.shalatSchedContent {\n  display: flex;\n}\n.shalatSchedContent .schedItem {\n  text-align: center;\n  border-left: 1px solid #306c4925;\n  padding: 0 1rem;\n}\n.schedItem:last-child {\n  border-right: 1px solid #306c4925;\n}\n.schedTime {\n  text-transform: capitalize;\n}\n.topNav {\n  padding: 0.5rem 2.5rem;\n  background: #87ad96;\n  margin-bottom: 1rem;\n}\n.topNav .topNavContainer {\n  width: 100%;\n  max-width: 1015px;\n  margin: auto;\n}\n.topNav .left {\n  display: flex;\n  position: absolute;\n  left: 0;\n  top: 16rem;\n  flex-direction: column;\n  text-align: left;\n  width: 100%;\n  background-color: #ddd;\n  z-index: 10;\n  max-height: 0;\n  overflow: hidden;\n  transition: all 0.2s ease-in-out;\n  -webkit-transition: all 0.2s ease-in-out;\n  -moz-transition: all 0.2s ease-in-out;\n  -ms-transition: all 0.2s ease-in-out;\n  -o-transition: all 0.2s ease-in-out;\n}\n.topNav .right {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  gap: 1.5rem;\n}\n.topNav .right li {\n  width: 10px;\n}\n.topNav .left li {\n  border-bottom: 1px solid #dadada;\n}\n.topNav .left a,\n.topNav .right a {\n  color: #333;\n  font-size: 0.88rem;\n  font-weight: bolder;\n  padding: 0.3rem;\n}\n.topNav .left a {\n  display: block;\n  padding: 0.8rem;\n}\nbutton.hamburger {\n  width: 100%;\n  padding: 0.6rem 0;\n  border: none;\n  font-size: 1.2rem;\n  cursor: pointer;\n}\n.surahSearch {\n  height: auto;\n  margin: 2rem 0;\n  display: flex;\n  justify-content: center;\n}\n.surahSearch input {\n  padding: 0.5rem 6rem 0.5rem 0.4rem;\n  border: transparent;\n  background-color: transparent;\n}\n.surahSearch .searchBoxContainer {\n  background-color: #eee;\n  width: auto;\n  padding-right: 0.4rem;\n  border: 1px solid #333;\n  overflow: hidden;\n  border-radius: 0.5rem;\n  -webkit-border-radius: 0.5rem;\n  -moz-border-radius: 0.5rem;\n  -ms-border-radius: 0.5rem;\n  -o-border-radius: 0.5rem;\n}\n.surahContainer {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));\n  gap: 1.2rem;\n  padding: 1rem;\n  margin-bottom: 2rem;\n}\n.surah {\n  background-color: #eee;\n  padding: 1rem;\n  border: 1px solid #333;\n  box-shadow: 7px 7px 0px rgba(0, 0, 0, 0.5);\n  border-radius: 0.4rem;\n  -webkit-border-radius: 0.4rem;\n  -moz-border-radius: 0.4rem;\n  -ms-border-radius: 0.4rem;\n  -o-border-radius: 0.4rem;\n  transition: all 0.3s ease-in-out;\n  -webkit-transition: all 0.3s ease-in-out;\n  -moz-transition: all 0.3s ease-in-out;\n  -ms-transition: all 0.3s ease-in-out;\n  -o-transition: all 0.3s ease-in-out;\n}\n.surah:hover {\n  background-color: #aec4b7;\n}\n.surah h2 {\n  font-size: 1.2rem;\n  margin-bottom: 0.5rem;\n}\n.arabic {\n  font-family: LPMQ, 'Traditional Arabic', Tahoma, sans-serif;\n  color: goldenrod;\n  line-height: 5rem;\n  font-weight: normal;\n  text-align: right;\n  direction: rtl;\n}\n.surahDetailContainer {\n  line-height: 1.5rem;\n}\n.surahDetailContainer .menu {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 1rem;\n}\n.surahDetailMain {\n  padding: 3rem 1rem;\n}\n.surahDetailContainer .titleContainer {\n  text-align: center;\n  font-size: 2rem;\n}\n.surahDetailContainer .titleContainer p {\n  font-size: 1.1rem;\n}\n.menu {\n  padding: 1rem;\n  font-size: 0.89rem;\n  color: #333;\n}\n.menu select {\n  border: 1px solid #555;\n  border-radius: 0.5rem;\n  -webkit-border-radius: 0.5rem;\n  -moz-border-radius: 0.5rem;\n  -ms-border-radius: 0.5rem;\n  -o-border-radius: 0.5rem;\n}\n.menu a {\n  font-size: 0.89rem;\n  color: #333;\n}\n.ayat,\n.tafsirBody {\n  background-color: #fafafa;\n  border: 1px solid #333;\n  margin-bottom: 2rem;\n  padding: 1rem 2rem;\n  overflow: hidden;\n  box-shadow: 7px 7px 0px rgba(0, 0, 0, 0.5);\n  transition: all 0.3s ease-in-out;\n  -webkit-transition: all 0.3s ease-in-out;\n  -moz-transition: all 0.3s ease-in-out;\n  -ms-transition: all 0.3s ease-in-out;\n  -o-transition: all 0.3s ease-in-out;\n  border-radius: 0.5rem;\n  -webkit-border-radius: 0.5rem;\n  -moz-border-radius: 0.5rem;\n  -ms-border-radius: 0.5rem;\n  -o-border-radius: 0.5rem;\n}\n.ayat:hover {\n  background-color: #efefef;\n  border-radius: 0.5rem;\n  -webkit-border-radius: 0.5rem;\n  -moz-border-radius: 0.5rem;\n  -ms-border-radius: 0.5rem;\n  -o-border-radius: 0.5rem;\n}\n.ayatsTitle {\n  font-size: 1.5rem;\n  margin: 2rem 0;\n  text-align: center;\n}\n.ayatHead {\n  text-align: right;\n}\n.ayatHead h3 {\n  font-size: 1rem;\n  line-height: 2.3rem;\n}\n.ayatHead h3.arabic {\n  margin-bottom: 0.5rem;\n}\n.ayatHead p {\n  color: #555;\n  font-size: 0.9rem;\n}\n.ayatBody p {\n  margin: 2rem 0;\n}\n.audioContainer {\n  display: flex;\n  align-items: center;\n}\naudio {\n  width: 170px;\n  transform: scale(0.8);\n  -webkit-transform: scale(0.8);\n  -moz-transform: scale(0.8);\n  -ms-transform: scale(0.8);\n  -o-transform: scale(0.8);\n}\naudio::-webkit-media-controls-panel {\n  background-color: #ddd;\n}\na.ayatTafsir {\n  font-size: 0.8rem;\n  background-color: #ddd;\n  color: #333;\n  padding: 0.5rem 0.7rem;\n  transition: all 0.3s ease-in-out;\n  -webkit-transition: all 0.3s ease-in-out;\n  -moz-transition: all 0.3s ease-in-out;\n  -ms-transition: all 0.3s ease-in-out;\n  -o-transition: all 0.3s ease-in-out;\n  border-radius: 0.5rem;\n  -webkit-border-radius: 0.5rem;\n  -moz-border-radius: 0.5rem;\n  -ms-border-radius: 0.5rem;\n  -o-border-radius: 0.5rem;\n}\na.ayatTafsir:hover {\n  background-color: #bbb;\n}\n.nomorAyat {\n  font-weight: bolder;\n  padding: 0.2rem 0.7rem;\n  background-color: #555;\n  color: white;\n  font-size: 0.9rem;\n  border-radius: 0.5rem;\n  -webkit-border-radius: 0.5rem;\n  -moz-border-radius: 0.5rem;\n  -ms-border-radius: 0.5rem;\n  -o-border-radius: 0.5rem;\n}\n.tafsirBody {\n  margin-top: 3rem;\n}\n.ayatFooter {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 0.6rem;\n}\nfooter {\n  background-color: #2c3e50;\n  text-align: center;\n  padding: 2rem 0;\n  color: var(--maincolor);\n  font-size: 0.9rem;\n}\n.loading {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 2rem 0;\n  position: fixed;\n  height: 100vh;\n  top: 0;\n  left: 0;\n  background-color: rgba(255, 255, 255, 0.8);\n  z-index: 100;\n}\n.hide {\n  display: none;\n}\n.lds-ripple {\n  display: inline-block;\n  position: relative;\n  width: 80px;\n  height: 80px;\n}\n.lds-ripple div {\n  position: absolute;\n  border: 4px solid #333;\n  opacity: 1;\n  border-radius: 50%;\n  animation: lds-ripple 1s cubic-bezier(0, 0.2, 0.8, 1) infinite;\n}\n.lds-ripple div:nth-child(2) {\n  animation-delay: -0.5s;\n}\n@keyframes lds-ripple {\n  0% {\n    top: 36px;\n    left: 36px;\n    width: 0;\n    height: 0;\n    opacity: 0;\n  }\n  4.9% {\n    top: 36px;\n    left: 36px;\n    width: 0;\n    height: 0;\n    opacity: 0;\n  }\n  5% {\n    top: 36px;\n    left: 36px;\n    width: 0;\n    height: 0;\n    opacity: 1;\n  }\n  100% {\n    top: 0px;\n    left: 0px;\n    width: 72px;\n    height: 72px;\n    opacity: 0;\n  }\n}\n@media screen and (min-width: 835px) {\n  header h1 {\n    font-size: 2.6rem;\n  }\n  .topNav .topNavContainer {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n  }\n  .topNav .left {\n    display: flex;\n    gap: 1.6rem;\n    flex-direction: row;\n    position: static;\n    background-color: transparent;\n    max-height: 100px;\n    width: auto;\n  }\n  .topNav .left li {\n    border-bottom: none;\n  }\n  .topNav .left a {\n    display: block;\n    padding: 0;\n  }\n  .surahDetailContainer .menu {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n  }\n  .surahDetailMain {\n    padding: 3rem;\n  }\n  .ayat {\n    padding: 2rem;\n  }\n  .menuAndNavDraw button {\n    display: none;\n  }\n  button.hamburger {\n    display: none;\n  }\n  .ayatHead h3 {\n    font-size: 1.3rem;\n  }\n  .ayatFooter {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    flex-wrap: wrap;\n  }\n  audio {\n    width: 300px;\n    transform: scale(0.9);\n    -webkit-transform: scale(0.9);\n    -moz-transform: scale(0.9);\n    -ms-transform: scale(0.9);\n    -o-transform: scale(0.9);\n  }\n}\n.show {\n  max-height: 1000px !important;\n}\n/* Colors */\n.audioPlaying {\n  background-color: rgba(218, 165, 32, 0.2);\n}\n.audioPlaying:hover {\n  background-color: rgba(218, 165, 32, 0.3);\n}\n.yellow {\n  color: rgb(191, 131, 20);\n}\n.gold {\n  color: goldenrod;\n}\n.logo {\n  color: goldenrod;\n  width: 3 rem;\n  height: 3 rem;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
